<ion-header>
    <ind-page-title [ngClass]="{'paddingScreen': inMeetingPresentationFlow && !fromInlineAllocation}" [viewData]='captureAllocationOrder' (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
    @if (bannerUrl) {
      <div class="productBanner">
        <img [src]="bannerUrl" alt="" />
      </div>
    }
  </ion-header>
<ion-content [ngClass]="(inMeetingPresentationFlow && !fromInlineAllocation)?'npPaddingScreenInPresentation':'paddingScreen'">
    <ion-grid>
        <ion-row justify-content-center>
            <ion-col class="orderCaptureScreenWrapper" size="auto">
                <ion-list>
                    <ind-section-header class="detailSectionHeader" [viewData]="detailsHeaderModel"></ind-section-header>
                    <div class="sampleInfoWrapper">
                        <ion-item *ngIf="activity.orderId">
                            {{'CAPTURE_ORD' |translate}} {{activity.orderId}} {{'ON' | translate}} {{getFormattedAndLocalisedDate(activity.orderDate)}}
                        </ion-item>
                        <ion-item *ngIf="activity.orderDateByUser">
                          {{'ALLOCATION_ORDER_DATE' |translate}}{{':'}} {{getFormattedAndLocalisedDateAndTime(activity.orderDateByUser)}}
                      </ion-item>
                        <ion-item>
                            {{activity.contactName}}
                        </ion-item>
                        <ng-container *ngIf="!isCompletedActivity">
                            <ion-item *ngFor="let license of sampleService.validatedLicenses; trackBy: trackById">
                                {{ license.typeLabel + ' | ' + license.licenseNumber }}
                            </ion-item>
                        </ng-container>
                        <ion-item text-wrap>
                            {{activity.location}}
                        </ion-item>
                    </div>
                    <p></p>
                    <ion-item *ngIf="!isLastDispatchDate" class="sampleDeatilsWrapper">
                        <ion-list style="width: 100%;">
                            <ion-grid>
                                <ion-row class="detailText detailTextTitle">
                                    <ion-col [size]="activity.isPromoMaterial ? '6' : '3'">{{'PRODUCT' | translate}}</ion-col>
                                    <ion-col *ngIf="!activity.isPromoMaterial" size="3">{{'CAPTURE_LOT' | translate}}</ion-col>
                                    <ion-col *ngIf="!activity.isPromoMaterial" size="3">{{'CAPTURE_EXPIRATION' | translate}}</ion-col>
                                    <ion-col [size]="activity.isPromoMaterial ? '6' : '3'">{{'QUANTITY' | translate}}</ion-col>
                                </ion-row>
                                <div *ngFor="let sample of nonDeletedSamplesData; trackBy: trackById" style="width: 100%;">
                                    <ion-row class="detailText" *ngFor="let lot of sample.lots; trackBy: trackById" style="width: 100%;">
                                        <ion-col [size]="activity.isPromoMaterial ? '6' : '3'">{{sample.indskr_skuname}}</ion-col>
                                        <ion-col *ngIf="!activity.isPromoMaterial" size="3">{{lot.indskr_lotname}}</ion-col>
                                        <ion-col *ngIf="!activity.isPromoMaterial" size="3">{{getLotExpirationDate(lot)}}</ion-col>
                                        <ion-col [size]="activity.isPromoMaterial ? '6' : '3'">{{lot.indskr_quantity}}</ion-col>
                                    </ion-row>
                                </div>
                            </ion-grid>
                        </ion-list>
                    </ion-item>
                    <ion-item *ngIf="isLastDispatchDate" class="sampleDeatilsWrapper">
                      <ion-list style="width: 100%;">
                          <ion-grid>
                              <ion-row class="detailText detailTextTitle">
                                  <ion-col [size]="activity.isPromoMaterial ? '6' : '2.4'">{{'PRODUCT' | translate}}</ion-col>
                                  <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{'CAPTURE_LOT' | translate}}</ion-col>
                                  <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{'AL_LAST_DISPATCH_DATE' | translate}}</ion-col>
                                  <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{'CAPTURE_EXPIRATION' | translate}}</ion-col>
                                  <ion-col [size]="activity.isPromoMaterial ? '6' : '2.4'">{{'QUANTITY' | translate}}</ion-col>
                              </ion-row>
                              <div *ngFor="let sample of nonDeletedSamplesData; trackBy: trackById" style="width: 100%;">
                                  <ion-row class="detailText" *ngFor="let lot of sample.lots; trackBy: trackById" style="width: 100%;">
                                      <ion-col [size]="activity.isPromoMaterial ? '6' : '2.4'">{{sample.indskr_skuname}}</ion-col>
                                      <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{lot.indskr_lotname}}</ion-col>
                                      <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{getLotLastDispatchDate(lot)}}</ion-col>
                                      <ion-col *ngIf="!activity.isPromoMaterial" size="2.4">{{getLotExpirationDate(lot)}}</ion-col>
                                      <ion-col [size]="activity.isPromoMaterial ? '6' : '2.4'">{{lot.indskr_quantity}}</ion-col>
                                  </ion-row>
                              </div>
                          </ion-grid>
                      </ion-list>
                    </ion-item>
                    <p></p>
                    <ind-section-header [viewData]="termsHeaderModel" (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
                    <ion-grid class="ion-margin-start">
                        <ion-row class='consent-terms'>
                            <div id="termBodyContainer" [ngClass]="isViewLess?'view-less':'view-all'" *ngIf="termBodyView" [innerHTML]="termBodyView" (click)="openUrl($event)"></div>
                            <div id="termBodyContainer" *ngIf="!termBodyView"><br></div>
                        </ion-row>
                    </ion-grid>
                    <p></p>
                    <ind-section-header [viewData]="signatureHeaderModel"></ind-section-header>
                    <ion-item class="agreementContainer" *ngIf="termBodyView && (isCompletedActivity || !this.consentService.allocationRemoteFlow)">
                      <div class="agreementContent">
                        <ion-label class="agreeText" text-wrap>{{ consentTerm.indskr_agreementmessage ||('I_AGREE_ON_TERMS' | translate)}}</ion-label>
                      </div>
                    </ion-item>
                    <ion-item class="confirmSignatureContainer" [ngClass]="{'confirmContainer': (!isCompletedActivity && !isSignatureAllowed)}">
                        @if (!isSignatureAllowed && !isCompletedActivity) {
                            <ion-button class="confirmTextBtn" [ngClass]="{'disabled':(!consentService.allocationRemoteFlow && !consentTerm.isAcceptedTerms)}"
                              (click)="openConfirmationPopup()" color="primary">
                                {{'CONFIRM' | translate}}
                            </ion-button>
                        }
                        @if (isSignatureAllowed && !isCompletedActivity) {
                            <div class="signatureImageContainer" [ngClass]="{'disabled':(!consentService.allocationRemoteFlow && !consentTerm.isAcceptedTerms)}">
                                @if (consentService.allocationRemoteFlow) {
                                    <!-- Remote flow: request signature from the HCP's own device -->
                                    <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag">
                                    <div class="ion-text-center signatureWrapper" [ngClass]="{'forceDisabled': remoteConnectionLost || isDeviceOffline}">
                                        <p class="ion-text-center" (click)="launchSignaturePad()">{{'CAPTURE_REMOTE_SIGN' | translate}}</p>
                                    </div>
                                } @else {
                                    <!-- Local flow: inline signature box kept in view with the sample list (OMNI-61520) -->
                                    <div class="inlineSignaturePadContainer">
                                        <div class="inlineSignatureBox">
                                            <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag inlineRedSignFlag">
                                            <signature-pad #sigPad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
                                        </div>
                                        <div class="inlineSignatureHint">{{'PLEASE_SIGN_ABOVE' | translate}}</div>
                                        <div class="inlineSignatureControls">
                                            <ion-button class="inlineSignatureBtn inlineSignatureClearBtn" fill="clear" color="primary" (click)="clearInlineSignature()">{{'CLEAR' | translate}}</ion-button>
                                            <ion-button class="inlineSignatureBtn inlineSignatureSubmitBtn" fill="solid" color="primary" [disabled]="!submitEnable" (click)="submitInlineSignature()">{{'SUBMIT' | translate}}</ion-button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (isCompletedActivity && activity.signature) {
                            <div class="signatureImageContainer capturedSignatureImageContainer">
                                <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag">
                                <div class="capturedImage signatureWrapper ion-text-center">
                                    <img [src]="activity.signature" width="100" height="100">
                                </div>
                            </div>
                        }
                    </ion-item>
                </ion-list>
            </ion-col>
            <ion-col size="2"></ion-col>
        </ion-row>
    </ion-grid>
</ion-content>

<!-- <ion-footer> -->
<footer-toolbar *ngIf="shouldShowFooter && footerService.fabNotRequestedFromPresentation('Sample')" [footerView]="'detailView'" [selectedView]="'CaptureSampleOrder'"></footer-toolbar>
<!-- </ion-footer> -->